// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"details_toolbar__3BnOw","periodText":"details_periodText__y75t7"};